import { useContext } from 'react';
import { Flex, Text, ColorContext, Devider, Box } from 'dash-ui';
import { GetFileDownloadsStatisticQuery } from 'gql/generated.graphql';
import styled from 'styled-components';

const ColorLabel = styled(Box)<{ color: any }>`
  background: linear-gradient(${({ color }) => color.join(', ')});
`;

const FileStatisticList = ({
  data,
}: {
  data: GetFileDownloadsStatisticQuery;
}) => {
  const { collection = [], totalCount } = data?.getFileDownloadsStatistic || {};
  const { gradientColorSets } = useContext(ColorContext);

  return (
    <Flex flex={1} flexDirection="column" w="100%" maxWidth={695}>
      {collection.map(({ file, count }, index) => (
        <Flex key={file._id} flexDirection="column" w="100%" flex={1}>
          <Flex w="100%" flex={1}>
            <Flex flex={3} overflow="hidden">
              <ColorLabel
                h={24}
                w={4}
                minWidth={4}
                color={gradientColorSets[index]}
                mr={3}
              />
              <Text ellipsis>{file.name}</Text>
            </Flex>
            <Flex justifyContent="flex-end" flex={1}>
              <Text>{count}</Text>
            </Flex>
            <Flex justifyContent="flex-end" flex={1}>
              <Text>{Math.round((100 * count) / totalCount)}%</Text>
            </Flex>
          </Flex>
          <Devider my={3} w="100%" />
        </Flex>
      ))}
    </Flex>
  );
};

export default FileStatisticList;
